/** Admin console date display: YYYY/MM/DD HH:mm (ja-JP, 24h). */
export function formatAdminDateTime(value: string | null | undefined): string {
	if (!value) return "—";
	const date = new Date(value);
	if (!Number.isFinite(date.getTime())) return "—";

	const y = date.getFullYear();
	const m = String(date.getMonth() + 1).padStart(2, "0");
	const d = String(date.getDate()).padStart(2, "0");
	const hh = String(date.getHours()).padStart(2, "0");
	const mm = String(date.getMinutes()).padStart(2, "0");
	return `${y}/${m}/${d} ${hh}:${mm}`;
}

/** Admin console date-only display: YYYY/MM/DD. */
export function formatAdminDate(value: string | null | undefined): string {
	if (!value) return "—";
	const date = new Date(value);
	if (!Number.isFinite(date.getTime())) return "—";

	const y = date.getFullYear();
	const m = String(date.getMonth() + 1).padStart(2, "0");
	const d = String(date.getDate()).padStart(2, "0");
	return `${y}/${m}/${d}`;
}
